import { ProductsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const productsClient = new ProductsApi(ecomConfiguration)
